var map = {
	"./tab111.png": "Yb4I",
	"./tab222.png": "EF8Z",
	"./tab333.png": "H9wQ",
	"./tab444.png": "JPYA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4GSq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabimg ^\.\/.*\.png$
// module id = 4GSq
// module chunks = 1